module.exports = __webpack_public_path__ + "static/media/profile-3.8ff2f0d8.jpeg";